import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgFullView24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Full View",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.25 20.54h-6.33a.75.75 0 0 1 0-1.5h5.58v-4.119a.75.75 0 0 1 1.5 0v4.869a.75.75 0 0 1-.75.75M9.079 20.54H2.75a.75.75 0 0 1-.75-.75v-4.869a.75.75 0 0 1 1.5 0v4.119h5.579a.75.75 0 0 1 0 1.5M21.25 9.829a.75.75 0 0 1-.75-.75V4.96h-5.58a.75.75 0 0 1 0-1.5h6.33a.75.75 0 0 1 .75.75v4.869a.75.75 0 0 1-.75.75M2.75 9.829a.75.75 0 0 1-.75-.75V4.21a.75.75 0 0 1 .75-.75h6.329a.75.75 0 0 1 0 1.5H3.5v4.119a.75.75 0 0 1-.75.75"
}));

export { SvgFullView24 as default };
//# sourceMappingURL=FullView24.js.map
